import { INewsClipped } from 'APIPackage/NewsModule/interfaces/INewsClipped';
import { TableColumnSortEnum } from 'CorePackage/MainModule/enums/TableColumnSortEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

export const initialNewsTableColumns: ITableColumn<INewsClipped>[] = [
  { id: 'type', name: 'Тип', sort: TableColumnSortEnum.NONE, isSelected: false },
  { id: 'status', name: 'Статус', sort: TableColumnSortEnum.NONE, isSelected: false },
  { id: 'title', name: 'Заголовок', sort: TableColumnSortEnum.NONE, isSelected: false },
  { id: 'shortText', name: 'Краткий текст новости', sort: TableColumnSortEnum.NONE, isSelected: false },
  { id: 'published', name: 'Дата публикации', sort: TableColumnSortEnum.NONE, isSelected: false },
];
